import { render, staticRenderFns } from "./UserDataTable.vue?vue&type=template&id=c4cdd3f2&scoped=true"
import script from "./UserDataTable.vue?vue&type=script&lang=js"
export * from "./UserDataTable.vue?vue&type=script&lang=js"
import style0 from "./UserDataTable.vue?vue&type=style&index=0&id=c4cdd3f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4cdd3f2",
  null
  
)

export default component.exports